import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfileContractTermsParams } from '@/shared/api/requests/club/contract-terms/post/request';
import { postClubProfileContractTerms } from '@/shared/api/requests/club/contract-terms/post/request';

export const useClubProfileContractTermsMutation = (
  settings?: MutationSettings<
    PostClubProfileContractTermsParams,
    typeof postClubProfileContractTerms
  >
) =>
  useMutation({
    mutationKey: ['ClubProfileContractTerms'],
    mutationFn: ({ params, config }) =>
      postClubProfileContractTerms({
        params,
        config
      }),
    ...settings?.options
  });
